"use client";

import Icon, {ICON_SIZES} from "@/components/library/Icon";
import {withClientPdf} from "./withClientPdf";

const PdfThumbnailInner = withClientPdf(() => import("./PdfThumbnailInner"), "sm");

const PdfThumbnail: React.FC<{file: string; width: number}> = ({file, width}) => (
   <div className="w-full h-full overflow-hidden pointer-events-none [&_canvas]:w-full [&_canvas]:h-auto">
      <PdfThumbnailInner file={file} width={width} fallback={
         <div className="w-full h-full flex items-center justify-center">
            <Icon icon="file-pdf" size={ICON_SIZES.XL} className="text-400" />
         </div>
      } />
   </div>
);

export default PdfThumbnail;
